import type { PropsWithChildren } from "react";

export function MenuField({ children }: PropsWithChildren) {
  // NOTE: py-1.5 makes it so that the default height of a `<MenuField><Input /></MenuField>` combo matches a
  // regular `<MenuItem>Text</MenuItem>`
  return (
    <label className="flex flex-row items-center gap-4 border-y border-transparent px-4 py-1.5 font-interest">
      {children}
    </label>
  );
}
